/**
 * Couleur d'un cycle : la couleur paramétrée au cycle si définie, sinon une
 * couleur stable dérivée du code (jamais aléatoire). Utilisée sur le planning,
 * les OF non affectés et les cartes TV pour une cohérence visuelle.
 */
const PALETTE = ['#3b82f6', '#8b5cf6', '#10b981', '#ef4444', '#f59e0b', '#06b6d4', '#ec4899'];

export function fallbackCycleColor(code: string): string {
  let hash = 0;
  for (const ch of code) hash = (hash * 31 + ch.charCodeAt(0)) >>> 0;
  return PALETTE[hash % PALETTE.length];
}

export function cycleColor(code: string, explicit: string | null | undefined): string {
  return explicit ?? fallbackCycleColor(code);
}
